import type { Listing } from '@thevillages/schemas';

import type { ListingsService } from '../listings';

export function ULIKey(this: ListingsService, listing: Listing, currentValue: boolean): boolean {
  // If no value is set, do not affect the filter.
  if (!this.filteringService.uliKey().length) {
    return currentValue;
  }

  // If the listing does not have a value, exclude it from results.
  if (!listing.uliKey) {
    return false;
  }
  if (listing.uliKey.toLowerCase() === 'map') {
    return currentValue;
  } // This is a remnant of the old map filter, which should not be affected by the new ULI key filter.

  // Determine if the listing matches the filter.
  if (this.filteringService.uliKey().toLowerCase() !== listing.uliKey.toLowerCase()) {
    return false;
  }

  // If the listing does not match the filter, do not affect the filter.
  return currentValue;
}
